import { makeStyles } from '@material-ui/core/styles'
import colors from '@bit/atd.web.colors'

export const useStyles = makeStyles({
  boxHeader: {
    position: 'relative',
    marginBottom: 16,
    '& > *': {
      color: '#2E2D31',
      fontSize: '14px',
      fontWeight: 600,
      lineHeight: '22px',
      letterSpacing: '0.8px',
      textTransform: 'uppercase',
    },
    '&::after': {
      content: '""',
      backgroundColor: colors.gray300,
      display: 'block',
      position: 'relative',
      marginTop: 8,
      width: '24px',
      height: '2px',
    },
  },
  activityItem: {},
  avatarWrapper: {},
  textWrapper: {
    paddingLeft: 8,
  },
  textName: {
    fontWeight: 600,
  },
  textXXSmall: {
    display: 'block',
    fontSize: '11px',
    lineHeight: '16px',
    textTransform: 'uppercase',
  },
  textContext: {
    marginTop: '4px',
  },
})
